<template>
  <footer v-if="showTrustedBy" :class="['fp-footer', `fp-footer--${theme}`]">
    <p class="fp-footer__label">Trusted by</p>
    <div class="fp-footer__logos">
      <img
        v-for="partner in partners"
        :key="partner.name"
        :src="partner.logo"
        :alt="partner.name"
        :style="{ width: partner.width }"
        class="fp-footer__logo"
      />
    </div>
  </footer>
</template>

<script>
import { PARTNERS, SHOW_TRUSTED_BY } from '@/components/front_page/designs/shared'

export default {
  name: 'FrontPageDesignFooter',
  props: {
    theme: {
      type: String,
      default: 'light',
    },
    showTrustedBy: { type: Boolean, default: SHOW_TRUSTED_BY },
  },
  data() {
    return { partners: PARTNERS }
  },
}
</script>

<style scoped>
.fp-footer {
  padding: 64px 24px 80px;
  text-align: center;
}

.fp-footer__label {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 32px;
}

.fp-footer__logos {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 32px 48px;
  max-width: 900px;
  margin: 0 auto;
}

.fp-footer__logo {
  max-width: 280px;
  height: auto;
  opacity: 0.85;
}

.fp-footer--light {
  background: #f5f5f5;
  color: #333;
}

.fp-footer--dark {
  background: #0a0a0a;
  color: #ccc;
}

.fp-footer--dark .fp-footer__logo {
  filter: brightness(0) invert(1);
  opacity: 0.7;
}
</style>
